import Rails from "@rails/ujs"

// Overrides default rails confirmation with Bootstrap 5 confirmation dialog
Rails.confirm = function (message, element) {
  let dialog = document.getElementById("confirmation-modal")
  let content = document.getElementById("confirmation-modal-content")
  let ok = document.getElementById("confirmation-ok-button")
  let modal = new window.bootstrap.Modal(dialog)

  content.textContent = message
  modal.show()

  ok.onclick = function(event) {
    event.preventDefault()
    modal.hide()
    Rails.confirm = function() { return true }
    element.click()
  }

  return false
}
